export const LIST_PAGE_SIZE = 5;
export const REPORT_PAGE_SIZE = 2;
export const CATALOG_PAGE_SIZE = 20;

export function paginate(items, page, pageSize = LIST_PAGE_SIZE) {
  const list = Array.isArray(items) ? items : [];
  const total = list.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize) || 1);
  const current = Math.min(Math.max(1, Number(page) || 1), totalPages);
  const start = (current - 1) * pageSize;
  const slice = list.slice(start, start + pageSize);
  return {
    items: slice,
    page: current,
    pageSize,
    total,
    totalPages,
    from: total ? start + 1 : 0,
    to: Math.min(total, start + slice.length),
  };
}

export function pageNumbers(current, total, delta = 1) {
  const pages = totalPagesSafe(total);
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const set = new Set([1, pages, current]);
  for (let i = current - delta; i <= current + delta; i++) {
    if (i >= 1 && i <= pages) set.add(i);
  }
  const sorted = [...set].sort((a, b) => a - b);
  const out = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i && sorted[i] - sorted[i - 1] > 1) out.push('…');
    out.push(sorted[i]);
  }
  return out;
}

function totalPagesSafe(total) {
  const n = Number(total) || 1;
  return n < 1 ? 1 : n;
}
